module.exports = __webpack_public_path__ + "img/tabbed-search-filter-nissan.aa163d6e.png";